// extracted by mini-css-extract-plugin
module.exports = {"navbar":"TopNavbar-module--navbar--2WQnE"};